export default "__VITE_ASSET__CG6s8kJ$__"